var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check text-center"},[_c('input',{staticClass:"form-check-input",class:_vm.value.class,attrs:{"type":"checkbox"},domProps:{"checked":_vm.value.selection.indexOf(_vm.value.id) >= 0},on:{"change":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }